import React from 'react'
import type { ListItemTextProps as MuiListItemTextProps } from '@material-ui/core/ListItemText'
import MuiListItemText from '@material-ui/core/ListItemText'

export type ListItemTextProps = MuiListItemTextProps

function ListItemText(props: ListItemTextProps) {
  return <MuiListItemText {...props} />
}

export default ListItemText
